import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet><ngx-spinner bdColor = "rgba(0,0,0,0.05)" size = "large" color = "#40219d" type = "ball-pulse" [fullScreen] = "true">
                <p style="color: #40219d" > لطفا منتظر بمانید ... </p></ngx-spinner>`
})
export class RootComponent {

}
